// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tree-node {
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
}
.tree-content {
  display: flex;
  align-items: center;
  padding: 3px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}
.tree-node:not(.selected) > .tree-content:hover {
  background: #f6f8fb;
}
.tree-node.selected > .tree-content {
  background-color: #e7eef7;
}
.tree-node.disabled > .tree-content:hover {
  background: inherit;
}
.tree-arrow {
  flex-shrink: 0;
  height: 30px;
  cursor: pointer;
  margin-left: 30px;
  width: 0;
}
.tree-arrow.has-child {
  margin-left: 0;
  width: 30px;
  position: relative;
}
.tree-arrow.has-child:after {
  border: 1.5px solid #494646;
  position: absolute;
  border-left: 0;
  border-top: 0;
  left: 9px;
  top: 50%;
  height: 9px;
  width: 9px;
  transform: rotate(-45deg) translateY(-50%) translateX(0);
  transition: transform .25s;
  transform-origin: center;
}
.tree-arrow.has-child.rtl:after {
  border: 1.5px solid #494646;
  position: absolute;
  border-right: 0;
  border-bottom: 0;
  right: 0px;
  top: 50%;
  height: 9px;
  width: 9px;
  transform: rotate(-45deg) translateY(-50%) translateX(0);
  transition: transform .25s;
  transform-origin: center;
}
.tree-arrow.expanded.has-child:after {
  transform: rotate(45deg) translateY(-50%) translateX(-5px);
}
.tree-checkbox {
  flex-shrink: 0;
  position: relative;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  border: 1px solid #dadada;
  border-radius: 2px;
  background: #fff;
  transition: border-color .25s, background-color .25s;
}
.tree-checkbox:after,
.tree-arrow:after {
  position: absolute;
  display: block;
  content: "";
}
.tree-checkbox.checked,
.tree-checkbox.indeterminate {
  background-color: #3a99fc;
  border-color: #218eff;
}
.tree-checkbox.checked:after {
  box-sizing: content-box;
  border: 1.5px solid #fff; /* probably width would be rounded in most cases */
  border-left: 0;
  border-top: 0;
  left: 9px;
  top: 3px;
  height: 15px;
  width: 8px;
  transform: rotate(45deg) scaleY(0);
  transition: transform .25s;
  transform-origin: center;
}
.tree-checkbox.checked:after {
  transform: rotate(45deg) scaleY(1);
}
.tree-checkbox.indeterminate:after {
  background-color: #fff;
  top: 50%;
  left: 20%;
  right: 20%;
  height: 2px;
}
.tree-anchor {
  flex-grow: 2;
  outline: none;
  display: flex;
  text-decoration: none;
  color: #343434;
  vertical-align: top;
  margin-left: 3px;
  line-height: 24px;
  padding: 3px 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.tree-node.selected > .tree-content > .tree-anchor {
  outline: none;
}
.tree-node.disabled > .tree-content > .tree-anchor {
  color: #989191;
  background: #fff;
  opacity: .6;
  cursor: default;
  outline: none;
}
.tree-input {
  display: block;
  width: 100%;
  height: 24px;
  line-height: 24px;
  outline: none;
  border: 1px solid #3498db;
  padding: 0 4px;
}
.l-fade-enter-active, .l-fade-leave-active {
  transition: opacity .3s, transform .3s;
  transform: translateX(0);
}
.l-fade-enter, .l-fade-leave-to {
  opacity: 0;
  transform: translateX(-2em);
}
.tree--small .tree-anchor {
  line-height: 19px;
}
.tree--small .tree-checkbox {
  width: 23px;
  height: 23px;
}
.tree--small .tree-arrow {
  height: 23px;
}
.tree--small .tree-checkbox.checked:after {
  left: 7px;
  top: 3px;
  height: 11px;
  width: 5px;
}
.tree-node.has-child.loading > .tree-content > .tree-arrow,
.tree-node.has-child.loading > .tree-content > .tree-arrow:after {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  border: 0;
}
.tree-node.has-child.loading > .tree-content > .tree-arrow {
  font-size: 3px;
  position: relative;
  border-top: 1.1em solid rgba(45,45,45, 0.2);
  border-right: 1.1em solid rgba(45,45,45, 0.2);
  border-bottom: 1.1em solid rgba(45,45,45, 0.2);
  border-left: 1.1em solid #2d2d2d;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  left: 5px;
  -webkit-animation: loading 1.1s infinite linear;
  animation: loading 1.1s infinite linear;
  margin-right: 8px;
}
@-webkit-keyframes loading {
0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
}
}
@keyframes loading {
0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
}
}
`, "",{"version":3,"sources":["webpack://./node_modules/vls-liquor-tree/src/components/TreeNode.vue"],"names":[],"mappings":";AA0cA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AACA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AACA;AAEA;EACA,mBAAA;AACA;AAEA;EACA,yBAAA;AACA;AAEA;EACA,mBAAA;AACA;AAEA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,QAAA;AACA;AAEA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AACA;AAEA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,wDAAA;EACA,0BAAA;EACA,wBAAA;AACA;AAEA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,wDAAA;EACA,0BAAA;EACA,wBAAA;AACA;AAEA;EACA,0DAAA;AACA;AAEA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AACA;AAEA;;EAEA,kBAAA;EACA,cAAA;EACA,WAAA;AACA;AAEA;;EAEA,yBAAA;EACA,qBAAA;AACA;AAEA;EACA,uBAAA;EACA,wBAAA,EAAA,kDAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,kCAAA;EACA,0BAAA;EACA,wBAAA;AACA;AAEA;EACA,kCAAA;AACA;AAEA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AACA;AAEA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AACA;AAEA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AACA;AAEA;EACA,sCAAA;EACA,wBAAA;AACA;AAEA;EACA,UAAA;EACA,2BAAA;AACA;AAGA;EACA,iBAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AACA;AAEA;EACA,YAAA;AACA;AAEA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AACA;AAEA;;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AACA;AAEA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,6CAAA;EACA,8CAAA;EACA,gCAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;EACA,SAAA;EACA,+CAAA;EACA,uCAAA;EACA,iBAAA;AACA;AAEA;AACA;IACA,+BAAA;IACA,uBAAA;AACA;AACA;IACA,iCAAA;IACA,yBAAA;AACA;AACA;AACA;AACA;IACA,+BAAA;IACA,uBAAA;AACA;AACA;IACA,iCAAA;IACA,yBAAA;AACA;AACA","sourcesContent":["<template>\n  <li\n    role=\"treeitem\"\n    class=\"tree-node\"\n    :data-id=\"node.id\"\n    :class=\"nodeClass\"\n    @mousedown.stop=\"handleMouseDown\"\n  >\n    <div\n      class=\"tree-content\"\n      :style=\"[options.direction == 'ltr' ? {'padding-left': padding} : {'padding-right': padding}]\"\n      @click.stop=\"select\"\n    >\n      <i\n        class=\"tree-arrow\"\n        :class=\"[{'expanded': node.states.expanded, 'has-child': node.children.length || node.isBatch}, options.direction]\"\n        @click.stop=\"toggleExpand\"\n      />\n\n      <i\n        v-if=\"options.checkbox\"\n        class=\"tree-checkbox\"\n        :class=\"{'checked': node.states.checked, 'indeterminate': node.states.indeterminate}\"\n        @click.stop=\"check\"\n      />\n\n      <span\n        ref=\"anchor\"\n        class=\"tree-anchor\"\n        tabindex=\"-1\"\n        @focus=\"onNodeFocus\"\n        @dblclick=\"tree.$emit('node:dblclick', node)\"\n      >\n        <node-content :node=\"node\" />\n      </span>\n    </div>\n\n    <transition name=\"l-fade\">\n      <ul\n        v-if=\"hasChildren() && node.states.expanded\"\n        class=\"tree-children\"\n      >\n        <node\n          v-for=\"child in visibleChildren\"\n          :key=\"child.id\"\n          :node=\"child\"\n          :options=\"options\"\n        />\n      </ul>\n    </transition>\n  </li>\n</template>\n\n<script>\n  import NodeContent from './NodeContent.vue'\n\n  const TreeNode = {\n    name: 'Node',\n    inject: ['tree'],\n    props: ['node', 'options'],\n\n    components: {\n      NodeContent\n    },\n\n    watch: {\n      node() {\n        this.node.vm = this\n      }\n    },\n\n    data() {\n      this.node.vm = this\n\n      return {\n        loading: false\n      }\n    },\n\n    computed: {\n      padding() {\n        return this.node.depth * (this.options.paddingLeft ? this.options.paddingLeft : this.options.nodeIndent) + 'px'\n      },\n\n      nodeClass() {\n        let state = this.node.states\n        let hasChildren = this.hasChildren()\n        let classes = {\n          'has-child': hasChildren,\n          'expanded': hasChildren && state.expanded,\n          'selected': state.selected,\n          'disabled': state.disabled,\n          'matched': state.matched,\n          'dragging': state.dragging,\n          'loading': this.loading,\n          'draggable': state.draggable\n        }\n\n        if (this.options.checkbox) {\n          classes['checked'] = state.checked\n          classes['indeterminate'] = state.indeterminate\n        }\n\n        return classes\n      },\n\n      visibleChildren() {\n        return this.node.children.filter(function(child) {\n          return child && child.visible()\n        })\n      }\n    },\n\n    methods: {\n      onNodeFocus() {\n        this.tree.activeElement = this.node\n      },\n\n      focus() {\n        this.$refs.anchor.focus()\n        this.node.select()\n      },\n\n      check() {\n        if (this.node.checked()) {\n          this.node.uncheck()\n        } else {\n          this.node.check()\n        }\n      },\n\n      select({ctrlKey} = evnt) {\n        const opts = this.options\n        const tree = this.tree\n        const node = this.node\n\n        tree.$emit('node:clicked', node)\n\n        if (opts.editing && node.isEditing) {\n          return\n        }\n\n        if (opts.editing && node.editable()) {\n          return this.startEditing()\n        }\n\n        if (opts.checkbox && opts.checkOnSelect) {\n          if (!opts.parentSelect && this.hasChildren()) {\n            return this.toggleExpand()\n          }\n\n          return this.check(ctrlKey)\n        }\n\n        // 'parentSelect' behaviour.\n        // For nodes which has a children list we have to expand/collapse\n        if (!opts.parentSelect && this.hasChildren()) {\n          this.toggleExpand()\n        }\n\n        if (opts.multiple) {\n          if (!node.selected()) {\n            node.select(ctrlKey)\n          } else {\n            if (ctrlKey) {\n              node.unselect()\n            } else {\n              if (this.tree.selectedNodes.length != 1) {\n                tree.unselectAll()\n                node.select()\n              }\n            }\n          }\n        } else {\n          if (node.selected() && ctrlKey) {\n            node.unselect()\n          } else {\n            node.select()\n          }\n        }\n      },\n\n      toggleExpand() {\n        if (this.hasChildren()) {\n          this.node.toggleExpand()\n        }\n      },\n\n      hasChildren() {\n        return this.node.hasChildren()\n      },\n\n      startEditing() {\n        if (this.tree._editingNode) {\n          this.tree._editingNode.stopEditing()\n        }\n\n        this.node.startEditing()\n      },\n\n      stopEditing() {\n        this.node.stopEditing()\n      },\n\n      handleMouseDown(event) {\n        if (!this.options.dnd) {\n          return\n        }\n\n        this.tree.vm.startDragging(this.node, event)\n      }\n    }\n  }\n\n  export default TreeNode\n</script>\n\n<style>\n  .tree-node {\n    white-space: nowrap;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-sizing: border-box;\n  }\n\n  .tree-content {\n    display: flex;\n    align-items: center;\n    padding: 3px;\n    cursor: pointer;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .tree-node:not(.selected) > .tree-content:hover {\n    background: #f6f8fb;\n  }\n\n  .tree-node.selected > .tree-content {\n    background-color: #e7eef7;\n  }\n\n  .tree-node.disabled > .tree-content:hover {\n    background: inherit;\n  }\n\n  .tree-arrow {\n    flex-shrink: 0;\n    height: 30px;\n    cursor: pointer;\n    margin-left: 30px;\n    width: 0;\n  }\n\n  .tree-arrow.has-child {\n    margin-left: 0;\n    width: 30px;\n    position: relative;\n  }\n\n  .tree-arrow.has-child:after {\n    border: 1.5px solid #494646;\n    position: absolute;\n    border-left: 0;\n    border-top: 0;\n    left: 9px;\n    top: 50%;\n    height: 9px;\n    width: 9px;\n    transform: rotate(-45deg) translateY(-50%) translateX(0);\n    transition: transform .25s;\n    transform-origin: center;\n  }\n\n  .tree-arrow.has-child.rtl:after {\n    border: 1.5px solid #494646;\n    position: absolute;\n    border-right: 0;\n    border-bottom: 0;\n    right: 0px;\n    top: 50%;\n    height: 9px;\n    width: 9px;\n    transform: rotate(-45deg) translateY(-50%) translateX(0);\n    transition: transform .25s;\n    transform-origin: center;\n  }\n\n  .tree-arrow.expanded.has-child:after {\n    transform: rotate(45deg) translateY(-50%) translateX(-5px);\n  }\n\n  .tree-checkbox {\n    flex-shrink: 0;\n    position: relative;\n    width: 30px;\n    height: 30px;\n    box-sizing: border-box;\n    border: 1px solid #dadada;\n    border-radius: 2px;\n    background: #fff;\n    transition: border-color .25s, background-color .25s;\n  }\n\n  .tree-checkbox:after,\n  .tree-arrow:after {\n    position: absolute;\n    display: block;\n    content: \"\";\n  }\n\n  .tree-checkbox.checked,\n  .tree-checkbox.indeterminate {\n    background-color: #3a99fc;\n    border-color: #218eff;\n  }\n\n  .tree-checkbox.checked:after {\n    box-sizing: content-box;\n    border: 1.5px solid #fff; /* probably width would be rounded in most cases */\n    border-left: 0;\n    border-top: 0;\n    left: 9px;\n    top: 3px;\n    height: 15px;\n    width: 8px;\n    transform: rotate(45deg) scaleY(0);\n    transition: transform .25s;\n    transform-origin: center;\n  }\n\n  .tree-checkbox.checked:after {\n    transform: rotate(45deg) scaleY(1);\n  }\n\n  .tree-checkbox.indeterminate:after {\n    background-color: #fff;\n    top: 50%;\n    left: 20%;\n    right: 20%;\n    height: 2px;\n  }\n\n  .tree-anchor {\n    flex-grow: 2;\n    outline: none;\n    display: flex;\n    text-decoration: none;\n    color: #343434;\n    vertical-align: top;\n    margin-left: 3px;\n    line-height: 24px;\n    padding: 3px 6px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  .tree-node.selected > .tree-content > .tree-anchor {\n    outline: none;\n  }\n\n  .tree-node.disabled > .tree-content > .tree-anchor {\n    color: #989191;\n    background: #fff;\n    opacity: .6;\n    cursor: default;\n    outline: none;\n  }\n\n  .tree-input {\n    display: block;\n    width: 100%;\n    height: 24px;\n    line-height: 24px;\n    outline: none;\n    border: 1px solid #3498db;\n    padding: 0 4px;\n  }\n\n  .l-fade-enter-active, .l-fade-leave-active {\n    transition: opacity .3s, transform .3s;\n    transform: translateX(0);\n  }\n\n  .l-fade-enter, .l-fade-leave-to {\n    opacity: 0;\n    transform: translateX(-2em);\n  }\n\n\n  .tree--small .tree-anchor {\n    line-height: 19px;\n  }\n\n  .tree--small .tree-checkbox {\n    width: 23px;\n    height: 23px;\n  }\n\n  .tree--small .tree-arrow {\n    height: 23px;\n  }\n\n  .tree--small .tree-checkbox.checked:after {\n    left: 7px;\n    top: 3px;\n    height: 11px;\n    width: 5px;\n  }\n\n  .tree-node.has-child.loading > .tree-content > .tree-arrow,\n  .tree-node.has-child.loading > .tree-content > .tree-arrow:after {\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    border: 0;\n  }\n\n  .tree-node.has-child.loading > .tree-content > .tree-arrow {\n    font-size: 3px;\n    position: relative;\n    border-top: 1.1em solid rgba(45,45,45, 0.2);\n    border-right: 1.1em solid rgba(45,45,45, 0.2);\n    border-bottom: 1.1em solid rgba(45,45,45, 0.2);\n    border-left: 1.1em solid #2d2d2d;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    left: 5px;\n    -webkit-animation: loading 1.1s infinite linear;\n    animation: loading 1.1s infinite linear;\n    margin-right: 8px;\n  }\n\n  @-webkit-keyframes loading {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes loading {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
